import { CompassCardUI } from '@scale/compass-ui/types';
import {
  TransformScriptCardShared,
  type TransformScriptSchemaType,
  type TransformScriptContext,
  TRANSFORM_SCRIPT,
  CompassTransformScript,
} from '@scale/genai-compass-shared/cards/transform_script';
import { faBracketsCurly } from '@fortawesome/pro-solid-svg-icons';
import TransformScriptComponent from 'react-scale/corp/views/DataCompassCardsV2/action/TransformScriptCard/TransformScriptComponent';

const defaultContext: TransformScriptContext = {
  cardType: TRANSFORM_SCRIPT,
  script: CompassTransformScript.HLE_MODEL_ATTEMPTS,
  scriptParams: {},
};

export const TransformScriptCardInfo: CompassCardUI<TransformScriptSchemaType> = {
  ...TransformScriptCardShared,
  title: 'Transform Script',
  icon: 'code',
  toolTip: 'Transform data using a custom script',
  defaultContext,
  isAdvanced: true,
  showOutput: true,
  button: {
    icon: faBracketsCurly,
  },
  legacyComponent: TransformScriptComponent,
};
